import script from "./AppHsForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AppHsForm.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__